import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAdvisories,
  resetStateAdvisories,
} from "../../app/slices/advisoriesSlice";
import LoadingContainer from "../../components/LoadingContainer/LoadingContainer";
import ErrorContainer from "../../components/ErrorContainer/ErrorContainer";
import AppDataTable from "../../components/AppDataTable/appDataTable";
import { Button } from "@mui/material";
import AdvisoryDialog from "./AdvisoryDialog";
import moment from "moment";
import { dateFormat } from "../../app/utils";

const AdvisoryManagement = () => {
  const { data, status, error } = useSelector(
    ({ advisories }) => advisories.get
  );
  const [list, setList] = useState(null);

  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [method, setMethod] = useState("ADD");
  const [selectedAdvisory, setSelectedAdvisory] = useState(null);
  const dispatch = useDispatch();

  const columns = [
    {
      name: "created_date",
      label: "Date Posted",
    },
    {
      name: "title",
      label: "Title",
    },
    {
      name: "overview_alt",
      label: "Overview",
    },
    {
      name: "description_alt",
      label: "Description",
    },
    {
      name: "source",
      label: "Source",
    },
    {
      name: "impact",
      label: "Impact",
    },
    {
      name: "statusDisplay",
      label: "Status",
    },
  ];

  //use effects
  useEffect(() => {
    loadResources();
    return () => {
      dispatch(resetStateAdvisories());
    };
  }, []);

  useEffect(() => {
    if (data?.length > 0) {
      let _list = [];
      data?.forEach((row) => {
        _list.push({
          ...row,
          created_date: moment(row?.created_date).format(dateFormat),
          statusDisplay:
            row?.status === "A"
              ? "Active"
              : row?.status === "I"
              ? "Inactive"
              : row?.status,
          description_alt:
            row?.description?.length > 60
              ? `${row?.description?.substring(0, 59)}...`
              : row?.description,
          overview_alt:
            row?.overview?.length > 60
              ? `${row?.overview?.substring(0, 59)}...`
              : row?.overview,
        });
      });
      setList(_list);
    } else {
      setList([]);
    }
  }, [data]);

  //methods
  const loadResources = () => {
    dispatch(resetStateAdvisories());
    dispatch(fetchAdvisories());
  };

  //builders
  return (
    <>
      <div className="app-padding mt-20 mb-50">
        <Button
          variant="outlined"
          onClick={() => {
            setMethod("ADD");
            setSelectedAdvisory(null);
            setIsOpenDialog(true);
          }}
        >
          + Post Advisory
        </Button>

        {status === "idle" && error === null && list && (
          <AppDataTable
            id="advisories-list"
            actions={[
              {
                action: "View",
                onClick: (item) => {
                  setMethod("VIEW");
                  setSelectedAdvisory({
                    ...item,
                    referenceNumber: item?.reference_number,
                    affectedSoftwares: item?.affected_softwares,
                    advisoryId: item?.advisory_id,
                    references: (() => {
                      let _refs = [];
                      (item?.references || []).forEach((item) => {
                        _refs.push(JSON.parse(item));
                      });
                      return _refs;
                    })(),
                  });
                  setIsOpenDialog(true);
                },
              },
              {
                action: "Update",
                onClick: (item) => {
                  setMethod("UPDATE");
                  setSelectedAdvisory({
                    ...item,
                    referenceNumber: item?.reference_number,
                    affectedSoftwares: item?.affected_softwares,
                    advisoryId: item?.advisory_id,
                    references: (() => {
                      let _refs = [];
                      (item?.references || []).forEach((item) => {
                        _refs.push(JSON.parse(item));
                      });
                      return _refs;
                    })(),
                  });
                  setIsOpenDialog(true);
                },
              },
            ]}
            columns={columns}
            data={list}
            emptyMessage="No advisories found."
            rowsPerPageOptions={[10, 20, 50, 100]}
            downloadFileName={`TzFincert advisories ${moment().format(
              "DD-MMM-YYYY"
            )}`}
          />
        )}
        {status === "loading" && (
          <LoadingContainer message={"Loading advisories..."} />
        )}
        {status !== "loading" && error && (
          <ErrorContainer message={error?.message} onReload={loadResources} />
        )}
      </div>

      {/* Advisory dialog */}
      {isOpenDialog && (method === "UPDATE" ? selectedAdvisory : true) && (
        <AdvisoryDialog
          selectedAdvisory={selectedAdvisory}
          open={isOpenDialog}
          method={method}
          onClose={(refresh) => {
            setIsOpenDialog(false);
            if (refresh) {
              setSelectedAdvisory(null);
              if (refresh) {
                loadResources();
              }
            }
          }}
          readOnly={method === "VIEW"}
          title={
            method === "VIEW"
              ? "View Advisory"
              : method === "ADD"
              ? "Post Advisory"
              : "Update Advisory"
          }
        />
      )}
      {/* Advisory dialog */}
    </>
  );
};

export default AdvisoryManagement;
